export const about = `
I provide front-end solutions, consulting services. My time is spent researching, programming, layouting websites from small, up to scale. I can assist from concept, layout, code, up to deployment.
`;

export const skills = {
  core: `
### Core Technologies

* HTML
* CSS
* Javascript
* Node.js
* Deployment
* Version Control
* Content Management System
  `,
  tools: `
### Tools Using

* React.js
* Bulma, Bootstrap, Material Design Lite
* Amazon Web Services (AWS), Heroku, Netlify
* Express.js, Next.js
* Git, Github, Gitlab
* Contentful CMS
  `
};

export const projects = {
  intro: `Recent projects, client work, volunteer work, and personal projects.`
};

const content = {
  about
};

export default content;
